import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';


import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { CommonService } from "../../../_common/_service/user.service";

@Component({
  selector: 'app-show-code',
  templateUrl: './show-code.component.html',
  styleUrls: ['./show-code.component.scss']
})
export class ShowCodeComponent implements OnInit {

  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  fullusername: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  codeUrl: any;
  
  
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  countryIsdcode: any;

  constructor(private authService: AuthService, private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {
    this.countryIsdcode = localStorage.getItem('countryIsdcode');
  
  }


  ngOnInit(): void {
    
    this.token = this.tokenStorageService.getToken();
     this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      
      this.generateQrCode();

    }
    else {
      this._service.callMethodOfSecondComponent();
    }

    if (this.currentUser.category == "MERCHANT") {
      this.getcompanyname();
    }
    else {

      this.fullusername =  this.currentUser.fullusername;
    }
   
  }

  Back() {

    this.router.navigate(['/Go-on']);
  }

  
  getcompanyname() {

    this.authService.getcompanyname().subscribe(
      (response: { apiStatus: any; apiData: any; }) => {
        
        this.fullusername = response.apiData.companyname;
       
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });
  }


  generateQrCode() {
    this.authService.generateQrCode(this.currentUser.serviceid).subscribe(response => {
      if (response.apiStatus == true) {
        
        this.codeUrl = response.apiData.qrCodePath;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }
  //openModal() {
  //  const dialogRef = this.dialog.open(, {
  //    data: null
  //  });

  //  dialogRef.afterClosed().subscribe(result => {
  //    if (result !== undefined && result !== null && result) {
  //    }
  //  });
  //}
}
